import { createApp } from 'vue';
import EpubToKepubConverter from '@/Components/EpubToKepubConverter.vue';
import '@styles/app.css';

createApp(EpubToKepubConverter).mount('#epub-to-kepub-converter');
